import { get } from 'lodash-es';
import { TRPCPost, getAxios } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';
import { logger } from '@/infrastructure/logger';
import { getPid, getProductId } from '@/infrastructure/product-info';
import { IssueType } from '@/proto/issue';
import { KeyDataType } from '@/proto/token';
import { IGetExtendInfoKeysRsp, IGetUserKeysRsp, IGetUserValuesReq, IGetUserValuesRsp, IUserKey } from '@/proto/user';


export const getBuglyCustomKeys = async () => {
  try {
    const resp = await getAxios().get(`/${API_PREFIX}/api/issue/classify/keys`, {
      params: {
        appId: getProductId(),
        pid: getPid(),
      },
    });

    return get(resp, 'data.data.keys', []);
  } catch (e) {
    return [];
  }
};

// 因IssueType无法匹配
export interface IGetKeysReq {
  productId?: string|null;
  issueType?: IssueType|null;
  issueId?: string|null;
  startTime?: number|null;
  endTime?: number|null;
  feature?: string;
}
/**
 * 获取自定义维度keys
 * @param params
 * @returns
 */
export const getCustomUserKeys = async (params: IGetKeysReq): Promise<IUserKey[]> => {
  try {
    const resp = await TRPCPost<IGetUserKeysRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.web_server.UserCustom/GetUserKeys`, params);
    return resp.keys || [];
  } catch (e) {
    logger.error('getDistributionKeys:', e);
    return [];
  }
};

/**
 * 获取自定义字段的keys
 * @param params
 * @returns
 */
export const getExtendInfoKeys = async (params: IGetKeysReq): Promise<IUserKey[]> => {
  try {
    const resp = await TRPCPost<IGetExtendInfoKeysRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.web_server.UserCustom/GetExtendInfoKeys`, params);
    const { keys = [] } = resp;

    return keys?.map((key: string) => ({
      label: key,
      key,
      type: KeyDataType.STRING,
    })) || [];
  } catch (e) {
    logger.error('getExtendInfoKeys:', e);
    return [];
  }
};

/**
 * 获取自定义字段的keys
 * @param params
 * @returns
 */
export const getKeyValues = async (params: IGetUserValuesReq): Promise<string[]> => {
  try {
    const resp = await TRPCPost<IGetUserValuesRsp>(`/${API_PREFIX}/trpc/trpc.rmonitor.web_server.UserCustom/GetUserValues`, params);
    return resp.userValues || [];
  } catch (e) {
    logger.error('getDistributionKeys:', e);
    return [];
  }
};
